"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildValueCaption = exports.DisplayFilterButton = void 0;
var React = require("react");
var CloseThickIcon_1 = require("../../../Icons/Assets/CloseThickIcon");
var Localization_1 = require("../../../Localization");
var Component_styles_1 = require("./Component.styles");
exports.DisplayFilterButton = React.forwardRef(function (props, ref) { return (React.createElement(Component_styles_1.WrapperDiv, null,
    React.createElement(ButtonCaption, __assign({ ref: ref }, props)))); });
var BuildValueCaption = function (value) {
    return value.map(function (item) { return item.Caption; }).join(", ");
};
exports.BuildValueCaption = BuildValueCaption;
var ButtonCaption = React.forwardRef(function (_a, ref) {
    var Active = _a.Active, Caption = _a.Caption, Value = _a.Value, OnRemove = _a.OnRemove, OnPickFilter = _a.OnPickFilter, DropdownVisible = _a.DropdownVisible;
    var handlePickFilter = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OnPickFilter();
    };
    var captionRef = React.createRef();
    var _b = React.useState(false), showMore = _b[0], setShowMore = _b[1];
    var buildValue = function () {
        if (Value && Value.length > 0) {
            return (React.createElement(React.Fragment, null,
                Caption,
                React.createElement("span", null, Localization_1.strings.FilterBar_Label_Is),
                exports.BuildValueCaption(Value)));
        }
        else {
            if (!DropdownVisible) {
                return Localization_1.strings.formatString(Localization_1.strings.FilterBar_Label_IsMissing, Caption).toString();
            }
        }
        return "" + Caption;
    };
    var calculateStyle = function () {
        if (!DropdownVisible && (!Value || Value.length === 0)) {
            return "Error";
        }
        if (Active) {
            return "Active";
        }
        return "";
    };
    React.useEffect(function () {
        if (Value && Value.length > 1 && captionRef.current.scrollWidth > captionRef.current.clientWidth) {
            setShowMore(true);
        }
        else {
            setShowMore(false);
        }
    }, [Value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Component_styles_1.Button, { "aria-label": Localization_1.strings.FilterBar_Label_EditFilter, title: Localization_1.strings.FilterBar_Label_EditFilter, onClick: handlePickFilter, ref: ref, Style: calculateStyle(), type: "button" },
            React.createElement(Component_styles_1.CaptionSpan, { ref: captionRef }, buildValue()),
            showMore && React.createElement("span", { style: { paddingLeft: "4px" } }, Localization_1.strings.FilterBar_Label_PlusMore)),
        React.createElement(Component_styles_1.Button, { "aria-label": Localization_1.strings.FilterBar_Label_RemoveFilter, onClick: OnRemove, Style: calculateStyle(), title: Localization_1.strings.FilterBar_Label_RemoveFilter, type: "button" },
            React.createElement(CloseThickIcon_1.CloseThickIcon, { Height: "16px", Width: "16px" }))));
});
